import React , {Component,Fragment} from 'react';
import {Link} from 'react-router-dom';
import JobsService from '../../../../services/JobsService';

export default class JobCard extends Component{
    constructor(props){
        super(props);
        this.state = {
            job : {
                id : props.job[0],
                name : props.job[1],
                qualifications : props.job[2],
                responsibilities : props.job[3],
            },
            isLoading : false
        };
        this.callApi = this.callApi.bind(this);
    };
    async callApi(){
        this.setState({
            isLoading : true
        });
        let response = await JobsService.show(this.props.id);
        this.setState({
            job : response.data,
            isLoading : false
        });
    }

    // async componentDidUpdate(prev){
    //     if(prev.id != this.props.id)
    //         await this.callApi();
    // }

    // async componentDidMount(){
    //     await this.callApi();
    // }

    render(){
        if(this.state.isLoading)
            return(
                <div className="card w-100">
                    <div className="card-body text-center">
                        <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
            );
        return(
            <Link to={`/careers/${this.state.job.id}`}>
                <div className="card w-100 m-2">
                        <div className="card-body">
                            <h5 className="card-title font-weight-bold text-dark">{this.state.job.name}</h5>
                            {/* <span className="card-subtitle mb-1 text-muted">{this.state.job.location} | {this.state.job.category} | {this.state.job.experience}</span> */}
                            {/* <p className="card-text text-truncate text-dark">{this.state.job.responsibilities.replace(';',' ')}</p> */}
                        </div>
                </div>
            </Link>
        );
    }
}